// FontAwesome Pro - Regular (far)
import {
  faAt,
  faBars,
  faCircle,
  faCirclePlus,
  faFaceFrown,
  faFaceMeh,
  faFaceSmile,
  faFontCase,
  faForward,
  faGift,
  faGripLines,
  faHashtag,
  faHeart,
  faPalette,
  faPhone,
  faRightFromBracket,
  faSquareArrowUpRight,
  faSquareInfo,
  faStarOfLife,
  faStopwatch,
  faTriangleExclamation,
  faTrophyStar,
  faUser,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';

/**
 * Single source of truth pairing each supported icon name (as used via JSON)
 * with its FontAwesome definition. The list, type, and definitions below are
 * all derived from this map, so a name can never drift out of sync with its definition.
 */
export const FarIconMap = {
  'far:at': faAt,
  'far:bars': faBars,
  'far:circle': faCircle,
  'far:circle-plus': faCirclePlus,
  'far:face-frown': faFaceFrown,
  'far:face-meh': faFaceMeh,
  'far:face-smile': faFaceSmile,
  'far:font-case': faFontCase,
  'far:forward': faForward,
  'far:gift': faGift,
  'far:grip-lines': faGripLines,
  'far:hashtag': faHashtag,
  'far:heart': faHeart,
  'far:palette': faPalette,
  'far:phone': faPhone,
  'far:right-from-bracket': faRightFromBracket,
  'far:square-arrow-up-right': faSquareArrowUpRight,
  'far:square-info': faSquareInfo,
  'far:star-of-life': faStarOfLife,
  'far:stopwatch': faStopwatch,
  'far:triangle-exclamation': faTriangleExclamation,
  'far:trophy-star': faTrophyStar,
  'far:user': faUser,
} satisfies Record<`far:${string}`, IconDefinition>;

/**
 * Generated type from the supported icon names.
 */
export type FarIcons = keyof typeof FarIconMap;

/**
 * The Supported Icon Names used via JSON.
 */
export const FarList = Object.keys(FarIconMap) as readonly FarIcons[];

/**
 * All FontAwesome Regular Icons available for the system
 * to use with Material Design are defined here.
 */
export const FarIconDefinitions: IconDefinition[] = Object.values(FarIconMap);
